import { render, staticRenderFns } from "./DeleteTierDialog.vue?vue&type=template&id=b8a18e24&"
import script from "./DeleteTierDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTierDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTierDialog.vue?vue&type=style&index=0&id=b8a18e24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports